import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import DataDashboard from '../components/DataDashboard.vue'
import IpBlacklistManagement from '../components/IpBlacklistManagement.vue'
import UserManagement from '../components/UserManagement.vue'  // 新增用户管理组件导入
import DistributionAccountManagement from '../components/DistributionAccountManagement.vue'  // 新增分销账户管理组件导入
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'  // 新增用户提现管理组件导入

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

export default new Router({
  mode: 'history', // 添加这一行以启用history模式
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/data-dashboard'
        },
        {
          path: '/data-dashboard',
          name: 'DataDashboard',
          component: DataDashboard
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/ip-blacklist',
          name: 'IpBlacklistManagement',
          component: IpBlacklistManagement
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/distribution-account',
          name: 'DistributionAccountManagement',
          component: DistributionAccountManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        }
      ]
    }
  ]
})